import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../../../../core/abstracts/baseComponent';
import { EmployeeReviewTemplateService } from '../../../../core/services/employee-review-template.service';
import { KraMetricResult } from '../../../../models/kraMetricModels';

@Component({ selector: 'app-metric-results', templateUrl: './metric-results.component.html', standalone: false })
export class MetricResultsComponent extends BaseComponent implements OnInit {
  results: KraMetricResult[] = [];
  loading = true;
  error = '';
  statuses = ['Met', 'Not Met', 'Neutral / Excluded', 'Insufficient Data', 'Not Configured'];
  constructor(private route: ActivatedRoute, private service: EmployeeReviewTemplateService) { super(); }
  ngOnInit() {
    const userID = Number(this.route.snapshot.params.userid || 0);
    this.subs.push(this.service.getMetricResults(userID).subscribe({ next: results => { this.results = results; this.loading = false; },
      error: err => { this.loading = false; this.error = typeof err.error === 'string' ? err.error : err.error?.message || err.message; } }));
  }
}
